import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import {
    PrestadorComissaoCargoResponse,
    PrestadorComissaoMembroAtualizarRequest,
    PrestadorComissaoMembroRemoverRequest,
    PrestadorComissaoMembroSalvarRequest,
    PrestadorComissoesPage,
    PrestadorComissoesParams
} from '@/core/api/sicom-api/registro/prestador/prestador-comissoes.model';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

@Injectable({ providedIn: 'root' })
export class PrestadorComissoesService extends BaseService {
    readonly PATH = SICOM_PATHS.registro.prestador.comissoes;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    listar(params: PrestadorComissoesParams, context?: HttpContext): Observable<PrestadorComissoesPage> {
        const httpParams = new HttpParams()
            .set('id', String(params.id))
            .set('uf', params.uf)
            .set('tipoComissao', params.tipoComissao)
            .set('composicao', params.composicao)
            .set('sortBy', params.sortBy)
            .set('direction', params.direction)
            .set('page', String(params.page))
            .set('size', String(params.size));

        return this.http.get<PrestadorComissoesPage>(this.PATH, { params: httpParams, context });
    }

    listarCargos(context?: HttpContext): Observable<PrestadorComissaoCargoResponse[]> {
        return this.http.get<PrestadorComissaoCargoResponse[]>(`${this.PATH}/cargos`, { context });
    }

    criar(request: PrestadorComissaoMembroSalvarRequest, context?: HttpContext): Observable<void> {
        return this.http.post<void>(`${this.PATH}/membros`, request, { context });
    }

    atualizar(request: PrestadorComissaoMembroAtualizarRequest, context?: HttpContext): Observable<void> {
        return this.http.put<void>(`${this.PATH}/membros`, request, { context });
    }

    remover(request: PrestadorComissaoMembroRemoverRequest, context?: HttpContext): Observable<void> {
        return this.http.delete<void>(`${this.PATH}/membros`, { body: request, context });
    }
}
